// extracted by mini-css-extract-plugin
export default {"container":"TableZeroState_container__yOzUu","helptext":"TableZeroState_helptext__mIjxv"};